import { useEffect, useState } from "react";
import {
  Stack,
  Drawer,
  Divider,
  Card,
  useTheme,
  Typography,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { useForm, useWatch } from "react-hook-form";

import { FormProvider } from "@app/components";
import { useRequestState, useResponsive } from "@app/hooks";
import { Strings } from "@app/constants";

import {
  fuels,
  kmsDriven,
  brandsData,
  years,
  transmissions,
  color,
} from "../../filters-data";
import { FilterHeader } from "./filters-headers";
import { RangeSlider } from "./range-slider";
import { SearchBox } from "./search-box";
import { BrandFilter } from "./brands-filter";
import { YearFilter } from "./years-filters";
import { KmDrivenFilter } from "./km-driven-filters";
import { FuelFilter } from "./fuel-filters";
import { useDispatch } from "react-redux";
import { brand } from "@app/modules/categories/slice";
import { selectBrandState } from "@app/modules/categories/selector";
import { TransmissionFilter } from "./transmission";
import { ColorFilter } from "./colorFilter";

const Filters = ({
  handleClear,
  selectedCount,
  priceRange,
  setPriceRange,
}: any) => {
  const [openBrands, setOpenBrands] = useState<Record<string, boolean>>({});
  const [openTransmission, setOpenTransmission] = useState<
    Record<string, boolean>
  >({});
  const [drawerOpen, setDrawerOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useResponsive("down", "md");
  const dispatch = useDispatch();

  const toggleBrand = (brand: string) => {
    setOpenBrands((prev) => ({
      ...prev,
      [brand]: !prev[brand],
    }));
  };

  const toggleTransmission = (brand: string) => {
    setOpenTransmission((prev) => ({
      ...prev,
      [brand]: !prev[brand],
    }));
  };

  // const filterBrands = (brands: typeof brandsData) => {
  //   if (!searchTerm) return brands;
  //   return brands
  //     ?.map((brand) => {
  //       const matchesBrand = brand?.name
  //         ?.toLowerCase()
  //         ?.includes(searchTerm?.toLowerCase());

  //       const filteredSubs = brand?.subBrands?.filter((sub) =>
  //         sub?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  //       );

  //       if (matchesBrand || filteredSubs?.length > 0) {
  //         return {
  //           ...brand,
  //           subBrands: filteredSubs?.length ? filteredSubs : brand?.subBrands,
  //         };
  //       }
  //       return null;
  //     })
  //     ?.filter(Boolean) as typeof brandsData;
  // };

  const { data: allBrandsNameData } = useRequestState({
    stateSelector: selectBrandState,
  });

  useEffect(() => {
    dispatch(brand());
  }, []);

  const FilterContent = (
    <Card
      sx={{
        p: 2,
        mt: 1.5,
        ml: isMobile ? 0 : 1,
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: 2,
        width: 280,
        overflowY: "scroll",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      <FilterHeader selectedCount={selectedCount} handleClear={handleClear} />
      <Divider sx={{ my: 1 }} />
      <RangeSlider
        title={Strings.filters.priceRange}
        min={0}
        max={100000000}
        step={100000}
        value={priceRange}
        onChange={(_event, newValue) => setPriceRange(newValue as number[])}
      />
      <Divider
        sx={{
          height: 10,
          mb: 2,
        }}
      />
      <SearchBox />

      <BrandFilter
        label={Strings.filters.brands}
        brands={allBrandsNameData}
        openBrands={openBrands}
        toggleBrand={toggleBrand}
      />

      <YearFilter years={years} />
      <Divider />
      <KmDrivenFilter kmsDriven={kmsDriven} />
      <Divider />
      <FuelFilter fuels={fuels} />
      <TransmissionFilter transmission={transmissions} />
      <ColorFilter color={color} />
    </Card>
  );

  return (
    <>
      {isMobile ? (
        <Stack
          sx={{
            mt: { xs: "3vh", md: 0 },
            width: "100%",
          }}
          justifyContent={"space-between"}
          flexDirection={"row"}
          alignItems="center"
        >
          <Stack
            justifyContent={"space-between"}
            flexDirection={"row"}
            alignItems="center"
            sx={{ width: "100%" }}
          >
            <Typography variant="h5">{Strings.heading.products}</Typography>
            <Typography
              variant="h5"
              sx={{
                display: "flex",
                gap: 1,
                cursor: "pointer",
              }}
              onClick={() => setDrawerOpen(true)}
            >
              {Strings.heading.filter}
              <Icon icon="proicons:filter" width={28} height={28} />
            </Typography>
          </Stack>
          <Drawer
            anchor="right"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
          >
            <Stack
              sx={{
                width: 290,
                p: 2,
                alignItems: "center",
              }}
            >
              {FilterContent}
            </Stack>
          </Drawer>
        </Stack>
      ) : (
        FilterContent
      )}
    </>
  );
};

export { Filters };
